import { KlassenTab } from './klassenTab';

export const myKlassenTabComponent = {
  template: require('./klassenTab.html'),
  controllerAs: 'ctrl',
  controller: KlassenTab,
};
